/**
 * `CachedAPI` — sibling namespace to `API`. Each leaf object owns the cache state for one
 * resource and delegates to `API` for the underlying HTTP fetch. Use this from feature code
 * whenever you want a cached read; reach for `API` directly only when you specifically need
 * an uncached fetch (e.g. after a write).
 */

import { CachedMissionControlAPI } from "./mission-control";
import { CachedRobotsAPI } from "./data/tables/robots";
import { CachedShiftsAPI } from "./data/tables/shifts";
import { CachedDropoffsAPI } from "./data/tables/dropoffs";
import { CachedTeamMembersAPI } from "./data/tables/team-members";
import { CachedJobsAPI } from "./data/tables/jobs";
import { CachedWeatherAPI } from "./weather";

export namespace CachedAPI {
	export const MissionControl = new CachedMissionControlAPI();
	export const Weather = new CachedWeatherAPI();
	export namespace Data {
		export const Robots = new CachedRobotsAPI();
		export const Shifts = new CachedShiftsAPI();
		export const Dropoffs = new CachedDropoffsAPI();
		export const TeamMembers = new CachedTeamMembersAPI();
		export const Jobs = new CachedJobsAPI();
	}
}
